import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getPage } from "../lib/api";
import DOMPurify from "dompurify";
import Blocks from "../components/Blocks";
import Seo from "../components/Seo";

export default function PageView({ fixedSlug }) {
  const params = useParams();
  const slug = fixedSlug || params.slug;
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setPage(null);
    setNotFound(false);
    getPage(slug).then(setPage).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="max-w-3xl mx-auto px-4 py-20 text-center min-h-[50vh]"><Seo title="Página no encontrada" noindex /><h1 className="font-heading text-2xl">Página no encontrada</h1></div>;
  if (!page) return <div className="max-w-3xl mx-auto px-4 py-20 min-h-[50vh]"><div className="h-64 bg-secondary animate-pulse rounded-sm" /></div>;

  return (
    <div className="max-w-3xl mx-auto px-4 py-10 min-h-[50vh]">
      <Seo title={page.seo_title || page.title} description={page.meta_description || `${page.title} de FABRIPAN, fabricante de equipamiento profesional para panaderías. Directo de fábrica a su panadería.`} keywords={page.keywords || `${page.title.toLowerCase()} fabripan`} />
      <h1 className="font-heading font-bold text-4xl tracking-tighter mb-6">{page.title}</h1>
      {page.content && (
        <div className="prose prose-neutral max-w-none prose-headings:font-heading text-muted-foreground leading-relaxed mb-8" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(page.content) }} />
      )}
      <Blocks blocks={page.blocks || []} testid="page-blocks" />
    </div>
  );
}
